import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import style from './pending.module.css'
import BoxComponent from '../ReuseComponent/BoxComponent'
import CardComponent from '../ReuseComponent/CardComponent'
import { database } from '../../utils/firebase'
// eslint-disable-next-line import/imports-first
import { path } from '../../utils/const'
import BackComponent from '../../components/BackComponent/BackComponent'

let pendingListener = null

const PendingApproval = () => {
  const [activeConsultation, setActiveConsultation] = useState([])
  const [activeCount, setActiveCount] = useState(0)
  const { me } = useSelector((state) => state.app)
  const [searchValue, setSearchValue] = useState('')
  const [pastSearchValue, setPastSearchValue] = useState('')

  const searchfunction = async (name) => {
    const filteredConsultations = pastSearchValue.filter((item) => {
      let pName = item?.patientName || ''

      return pName.toLowerCase().includes(name.toLowerCase())
    })
    setActiveConsultation(filteredConsultations)
  }

  useEffect(() => {
    pendingListener = database
      .ref(`/delegateChats`)
      .orderByChild('status')
      .equalTo('pending')
    pendingListener.on('value', (pendingSnapshot) => {
      const pendingConsultationJSON = pendingSnapshot.toJSON() || {}
      let pendingConsultationData = Object.keys(pendingConsultationJSON)
      pendingConsultationData = pendingConsultationData.map((key) => {
        return { ...pendingConsultationJSON[key], id: key }
      })
      
      pendingConsultationData = pendingConsultationData.sort((a, b) => {
        return (b.timestamp || 0) - (a.timestamp || 0);
      });
      
      if (me.role === 'Doctor') {
        pendingConsultationData = pendingConsultationData.filter(
          (convo) => convo.doctorID === me.id,
        )
      }

      setPastSearchValue(pendingConsultationData)

      setActiveConsultation(pendingConsultationData)
      setActiveCount(pendingConsultationData.length)
    })

    return () => {
      if (pendingListener) {
        pendingListener.off()
        pendingListener = null
      }
    }
  }, [])
  return (
    <div>
      <div className={style.pastScroll}>
        <BackComponent
          activeCount={activeCount}
          title={'Pending scripts'}
          dashboard={path.dashboard}
        />
        <BoxComponent />

        <div className={style.approval}>
          <div className="d-flex">
            <div className={style.redDot}></div>
            <span>Authorisation compulsory</span>
          </div>
        </div>
        <div className={style.line}></div>
        {
          <div className={style.searchDiv}>
            <input
              className={style.search}
              type="text"
              placeholder="Search patients"
              onChange={(event) => {
                setSearchValue(event.target.value)
              }}
            />
            <button
              className={style.searchButton}
              onClick={(event) => searchfunction(searchValue)}
            >
              Search
            </button>
          </div>
        }
        <div className={style.line}></div>

        {activeConsultation.map((obj) => {
          return (
            <div key={obj.id}>
              <CardComponent
                forwardPath={path.consultation}
                greenColor={'#38C763'}
                archiveID={obj.id}
                delegateData={obj}

              />
            </div>
          )
        })}

        <div className={style.bottomPadding}></div>
      </div>
    </div>
  )
}
export default PendingApproval
